import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class MonthlyDistanceReportStore {
    loading = false;
    total = 0;
    monthlyDistance = [];
    tripData = [];

    rootStore;

    constructor(rootStore) {
        makeObservable(this, {
            loading: observable,
            total: observable,
            monthlyDistance: observable,
            tripData: observable,

            loadData: action,

            exportExcel: action,
            exportpdf: action,
        });
        this.rootStore = rootStore;
    }

    async loadData({
        companyId,
        vehicleId,
        fromDate,
        toDate,
        offset,
        limit,
        pageNo,
        reportName
    }) {
        this.loading = true;
        var postData = {
            companyId: companyId,
            vehicleId: vehicleId,
            fromDate: fromDate,
            toDate: toDate,
            offset: offset,
            limit: limit,
            reportName: reportName,
            interval: 0,
            page: pageNo
        };

        var response = await postApi.getClient("report").post("/tracking_report/distancereport", postData);


        this.total = parseInt(response?.data?.data?.TotalCount);
        this.monthlyDistance = response?.data?.data?.distanceReport
        this.pageSize = this.monthlyDistance?.length
        this.loading = false;
    }

    async exportExcel(getData) {
        try {
            await postApi.getClient("report").post("/tracking_report/distanceReport/download/excel", getData, {
                responseType: "blob",
            });
            this.pythonReportMessage = true;
        } catch (error) {
            this.pythonReportErrorMessage = true;
        }
    }

    async exportpdf(getData) {
        try {
            await postApi.getClient("report").post("/tracking_report/distanceReport/download/pdf", getData, {
                responseType: "blob",
            });
            this.pythonReportMessage = true;
        } catch (error) {
            this.pythonReportErrorMessage = true;
        }
    }
}

export default MonthlyDistanceReportStore;
